document.querySelectorAll('.range-slider-wrapper').forEach(wrapper => {
    const slider = wrapper.querySelector('.range-slider');
    wrapper.querySelector('.next').onclick = () => {
      slider.scrollBy({ left: 360, behavior: 'smooth' });
    };
    wrapper.querySelector('.prev').onclick = () => {
      slider.scrollBy({ left: -360, behavior: 'smooth' });
    };
  });